import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { AlertService } from 'services/alert.service';
import { PasswordStrengthValidator } from 'app/shared/validators/password-strength.validators';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-changepassword',
    templateUrl: './referfriends-banner-dailog.component.html',
    styleUrls: ['./referfriends-banner-dailog.component.scss']
})
export class ReferFriendsBannerComponent implements OnInit {
    referralUrl: any;
    showReferralUrl: boolean = false;
    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        private route: ActivatedRoute,
        private alertService: AlertService,
        @Optional() public dialogRef: MatDialogRef<ReferFriendsBannerComponent>) {
    }

    ngOnInit(): void {
        // $('#bannerModal').modal('show');
        if (this.data && this.data.referralUrl) {
            this.referralUrl = this.data.referralUrl;
            this.showReferralUrl = true;
        }
    }

    closeBanner(): void {
        this.dialogRef.close(false);
    }

    copyReferralUrl() {
        const textarea = document.createElement('textarea');
        textarea.value = this.referralUrl;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy'); // Angular 8 compatible		
        document.body.removeChild(textarea);
        this.alertService.success('Referral link copied to clipboard!');
    }
}
